import { render } from "./CreateWorkOrder.vue?vue&type=template&id=361ea6a3&scoped=true"
import script from "./CreateWorkOrder.vue?vue&type=script&lang=js"
export * from "./CreateWorkOrder.vue?vue&type=script&lang=js"

import "./CreateWorkOrder.vue?vue&type=style&index=0&id=361ea6a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361ea6a3"]])

export default __exports__